define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Model = /** @class */ (function () {
        function Model(data, _schema) {
            this._schema = _schema;
            this.attributes = {};
            // pas ici
            if (Object.keys(data).length === 2 && data["version"] !== undefined && data["attributes"] !== undefined) {
                // formatted object
                this.attributes = data["attributes"];
                this.version = data["version"];
            }
            else {
                // raw object
                this.attributes = data;
            }
        }
        Model.prototype.fromStore = function (data) {
            if (Object.keys(data).length === 2 && data["version"] !== undefined && data["attributes"] !== undefined) {
                // formatted object
                this.attributes = data["attributes"];
                this.version = data["version"];
            }
            else {
                // raw object
                this.attributes = data;
            }
        };
        Model.prototype.fromFront = function (data) {
        };
        Object.defineProperty(Model.prototype, "validated", {
            get: function () {
                return this._schema.validateModel(this.attributes, this.version);
            },
            enumerable: true,
            configurable: true
        });
        Model.prototype.toJSON = function () {
            return JSON.stringify(this.attributes);
        };
        return Model;
    }());
    exports.Model = Model;
});
